<template>
  <div class="leftmenu">
    <div class="userinfo">
      <img :src="avatar" alt="" class="avatar" />
      <div class="username">{{ userName }}</div>
      <router-link
        tag="button"
        :to="{ path: '/personal-center/edit-info' }"
        class="edit"
        >编辑资料</router-link
      >
    </div>
    <div class="menu-list">
      <div class="menu-box">
        <!-- <router-link
          tag="div"
          :to="{ path: '/personal-center/my-works' }"
          class="menu-item"
          >我的作品</router-link
        > -->
        <router-link
          tag="div"
          :to="{ path: '/personal-center/new-notice' }"
          class="menu-item"
          >消息通知</router-link
        >
        <router-link
          v-if="false"
          tag="div"
          :to="{ path: '/personal-center/bind-weixin' }"
          class="menu-item"
          >绑定微信</router-link
        >
        <router-link tag="div" :to="{ path: '/awards' }" class="menu-item">
          我的证书
        </router-link>
        <router-link tag="div" :to="{ path: '/myReader' }" class="menu-item">
          我的阅读
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
const avatar_no = require("@/assets/img/avatar_no.png");

export default {
  components: {},
  props: {
    userinfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    userName() {
      return this.userinfo.nickname;
    },
    avatar() {
      return this.userinfo.head_portrait
        ? this.userinfo.head_portrait
        : avatar_no;
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.leftmenu {
  width: 360px;
  display: flex;
  flex-direction: column;
  .userinfo {
    border-radius: 10px;
    margin: 30px 0;
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: #16224d;
      overflow: hidden;
    }
    .username {
      margin: 30px auto;
      width: 150px;
      @include text-dot(1);
    }
    .edit {
      font-size: 14px;
      width: 100px;
      height: 40px;
      border: 1px solid #999;
      border-radius: 40px;
      color: #999;
      background-color: #fff;
      cursor: pointer;
    }
  }
  .menu-list {
    padding: 0 0 30px;
    .menu-box {
      border-radius: 10px;
      overflow: hidden;
      background-color: #fff;
      .menu-item {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        &.active {
          background-color: #16224d;
          color: #fff;
        }
      }
      .router-link-active {
        background-color: #16224d;
        color: #fff;
      }
    }
  }
}
</style>
